// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700;800;900&family=Fredoka:wght@400;500;600;700&family=Poppins:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Kid-friendly vibrant color palette */
  --color-primary: #ff6b9d;       /* Playful pink */
  --color-primary-dark: #e8457a;
  --color-primary-light: #ffb3d0;
  --color-secondary: #7c3aed;     /* Fun purple */
  --color-secondary-light: #a78bfa;
  --color-tertiary: #06b6d4;      /* Bright turquoise */
  --color-tertiary-light: #67e8f9;
  --color-background: #fffbf7;    /* Warm cream */
  --color-surface: #ffffff;
  --color-muted: #fef3ff;         /* Light lavender */
  --color-accent: #fbbf24;        /* Bright yellow */
  --color-accent-orange: #fb923c; /* Fun orange */
  --color-accent-green: #4ade80;  /* Lime green */
  --color-accent-blue: #60a5fa;   /* Sky blue */
  --color-text: #1e1b4b;          /* Deep purple-black */
  --color-text-muted: #6b7280;
  --max-width: 1200px;

  /* Rounder, more playful borders */
  --radius-xl: 32px;
  --radius-lg: 24px;
  --radius-md: 16px;
  --radius-sm: 12px;
  --radius-round: 9999px;

  /* Playful shadows */
  --shadow-soft: 0 20px 40px rgba(124, 58, 237, 0.1);
  --shadow-card: 0 25px 60px rgba(255, 107, 157, 0.12);
  --shadow-glow: 0 0 30px rgba(124, 58, 237, 0.2);
  --shadow-fun: 8px 8px 0 rgba(124, 58, 237, 0.15);

  /* Responsive spacing */
  --spacing-page: 1.5rem;
  --spacing-section: 5rem;

  /* Fun gradients */
  --gradient-rainbow: linear-gradient(135deg, #ff6b9d 0%, #fbbf24 25%, #4ade80 50%, #06b6d4 75%, #7c3aed 100%);
  --gradient-sunset: linear-gradient(135deg, #ff6b9d 0%, #fb923c 50%, #fbbf24 100%);
  --gradient-ocean: linear-gradient(135deg, #06b6d4 0%, #7c3aed 100%);
  --gradient-candy: linear-gradient(135deg, #ff6b9d 0%, #a78bfa 100%);
}

/* Responsive breakpoint variables via media queries */
@media (max-width: 768px) {
  :root {
    --spacing-page: 1rem;
    --spacing-section: 2.5rem;
    --radius-lg: 18px;
    --radius-md: 12px;
  }
}

@media (max-width: 480px) {
  :root {
    --spacing-page: 0.75rem;
    --spacing-section: 2rem;
    --radius-lg: 14px;
    --radius-md: 10px;
  }
}

* {
  box-sizing: border-box;
}

html {
  /* Smooth scrolling for anchor links */
  scroll-behavior: smooth;
  /* Prevent horizontal overflow */
  overflow-x: hidden;
}

html, body, #root {
  margin: 0;
  padding: 0;
  min-height: 100%;
  background: var(--color-background);
  font-family: 'Nunito', 'Fredoka', 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: var(--color-text);
  /* Prevent horizontal overflow */
  overflow-x: hidden;
  width: 100%;
}

/* Responsive font sizing */
html {
  font-size: 16px;
}

@media (max-width: 768px) {
  html {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  html {
    font-size: 14px;
  }
}

a {
  color: inherit;
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

img {
  max-width: 100%;
  height: auto;
  display: block;
}

button {
  font-family: inherit;
}

/* Ensure inputs and buttons don't overflow on mobile */
input, select, textarea, button {
  max-width: 100%;
}

/* Better touch targets on mobile */
@media (max-width: 768px) {
  button, 
  a[role="button"],
  input[type="submit"],
  input[type="button"] {
    min-height: 44px;
  }
}

/* Hide horizontal scrollbars that might appear */
body {
  overflow-x: hidden;
}

/* Responsive container utility */
.container {
  width: 100%;
  max-width: var(--max-width);
  margin-inline: auto;
  padding-inline: var(--spacing-page);
}

/* ===== KID-FRIENDLY ANIMATIONS ===== */

/* Bounce animation */
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

/* Wiggle animation */
@keyframes wiggle {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-3deg); }
  75% { transform: rotate(3deg); }
}

/* Pop animation */
@keyframes pop {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Float animation */
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

/* Sparkle animation */
@keyframes sparkle {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(1.2); }
}

/* Rainbow text animation */
@keyframes rainbow {
  0% { color: #ff6b9d; }
  20% { color: #fb923c; }
  40% { color: #fbbf24; }
  60% { color: #4ade80; }
  80% { color: #06b6d4; }
  100% { color: #7c3aed; }
}

/* Pulse glow */
@keyframes pulseGlow {
  0%, 100% { box-shadow: 0 0 20px rgba(255, 107, 157, 0.4); }
  50% { box-shadow: 0 0 40px rgba(255, 107, 157, 0.6); }
}

/* Slide up fade in */
@keyframes slideUpFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Confetti animation */
@keyframes confettiFall {
  0% {
    transform: translateY(-100vh) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(720deg);
    opacity: 0;
  }
}

/* Utility classes for animations */
.animate-bounce {
  animation: bounce 2s ease-in-out infinite;
}

.animate-wiggle {
  animation: wiggle 1s ease-in-out infinite;
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}

.animate-pop:hover {
  animation: pop 0.3s ease-in-out;
}

.animate-sparkle {
  animation: sparkle 2s ease-in-out infinite;
}

.animate-pulse-glow {
  animation: pulseGlow 2s ease-in-out infinite;
}

.animate-slide-up {
  animation: slideUpFadeIn 0.5s ease-out forwards;
}

/* Fun text styles */
.text-gradient-rainbow {
  background: var(--gradient-rainbow);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.text-gradient-candy {
  background: var(--gradient-candy);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Playful heading style */
h1, h2, h3, h4, h5, h6 {
  font-family: 'Fredoka', 'Nunito', sans-serif;
  font-weight: 700;
}

/* Fun button hover effect */
button, a[role="button"], .btn {
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

button:hover, a[role="button"]:hover, .btn:hover {
  transform: translateY(-3px) scale(1.02);
}

button:active, a[role="button"]:active, .btn:active {
  transform: translateY(-1px) scale(0.98);
}

/* Decorative dots pattern */
.pattern-dots {
  background-image: radial-gradient(circle, var(--color-primary-light) 2px, transparent 2px);
  background-size: 24px 24px;
}

/* Decorative waves */
.pattern-waves {
  background:
    repeating-linear-gradient(
      45deg,
      transparent,
      transparent 10px,
      rgba(255, 107, 157, 0.05) 10px,
      rgba(255, 107, 157, 0.05) 20px
    );
}

/* Card with fun shadow */
.card-fun {
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-fun);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-fun:hover {
  transform: translateY(-5px);
  box-shadow: 12px 12px 0 rgba(124, 58, 237, 0.2);
}

`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAEA;EACE,uCAAuC;EACvC,wBAAwB,QAAQ,iBAAiB;EACjD,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B,MAAM,eAAe;EAC/C,gCAAgC;EAChC,yBAAyB,OAAO,qBAAqB;EACrD,+BAA+B;EAC/B,2BAA2B,KAAK,eAAe;EAC/C,wBAAwB;EACxB,sBAAsB,UAAU,mBAAmB;EACnD,uBAAuB,SAAS,kBAAkB;EAClD,8BAA8B,EAAE,eAAe;EAC/C,6BAA6B,GAAG,eAAe;EAC/C,4BAA4B,IAAI,aAAa;EAC7C,qBAAqB,WAAW,sBAAsB;EACtD,2BAA2B;EAC3B,mBAAmB;;EAEnB,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;;EAEtB,oBAAoB;EACpB,kDAAkD;EAClD,oDAAoD;EACpD,+CAA+C;EAC/C,gDAAgD;;EAEhD,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;;EAEvB,kBAAkB;EAClB,4GAA4G;EAC5G,iFAAiF;EACjF,mEAAmE;EACnE,mEAAmE;AACrE;;AAEA,sDAAsD;AACtD;EACE;IACE,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mCAAmC;EACnC,sGAAsG;EACtG,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,uDAAuD;AACvD;EACE,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,wCAAwC;;AAExC,qBAAqB;AACrB;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA,qBAAqB;AACrB;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,wBAAwB,EAAE;EAChC,MAAM,uBAAuB,EAAE;AACjC;;AAEA,kBAAkB;AAClB;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,oBAAoB;AACpB;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA,sBAAsB;AACtB;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,YAAY,EAAE,qBAAqB,EAAE;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,KAAK,cAAc,EAAE;EACrB,MAAM,cAAc,EAAE;EACtB,MAAM,cAAc,EAAE;EACtB,MAAM,cAAc,EAAE;EACtB,MAAM,cAAc,EAAE;EACtB,OAAO,cAAc,EAAE;AACzB;;AAEA,eAAe;AACf;EACE,WAAW,6CAA6C,EAAE;EAC1D,MAAM,6CAA6C,EAAE;AACvD;;AAEA,qBAAqB;AACrB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,0CAA0C;IAC1C,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA,mCAAmC;AACnC;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,sDAAsD;AACxD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;EACE,0FAA0F;EAC1F,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE;;;;;;;KAOG;AACL;;AAEA,yBAAyB;AACzB;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700;800;900&family=Fredoka:wght@400;500;600;700&family=Poppins:wght@400;500;600;700;800&display=swap');\n\n:root {\n  /* Kid-friendly vibrant color palette */\n  --color-primary: #ff6b9d;       /* Playful pink */\n  --color-primary-dark: #e8457a;\n  --color-primary-light: #ffb3d0;\n  --color-secondary: #7c3aed;     /* Fun purple */\n  --color-secondary-light: #a78bfa;\n  --color-tertiary: #06b6d4;      /* Bright turquoise */\n  --color-tertiary-light: #67e8f9;\n  --color-background: #fffbf7;    /* Warm cream */\n  --color-surface: #ffffff;\n  --color-muted: #fef3ff;         /* Light lavender */\n  --color-accent: #fbbf24;        /* Bright yellow */\n  --color-accent-orange: #fb923c; /* Fun orange */\n  --color-accent-green: #4ade80;  /* Lime green */\n  --color-accent-blue: #60a5fa;   /* Sky blue */\n  --color-text: #1e1b4b;          /* Deep purple-black */\n  --color-text-muted: #6b7280;\n  --max-width: 1200px;\n\n  /* Rounder, more playful borders */\n  --radius-xl: 32px;\n  --radius-lg: 24px;\n  --radius-md: 16px;\n  --radius-sm: 12px;\n  --radius-round: 9999px;\n\n  /* Playful shadows */\n  --shadow-soft: 0 20px 40px rgba(124, 58, 237, 0.1);\n  --shadow-card: 0 25px 60px rgba(255, 107, 157, 0.12);\n  --shadow-glow: 0 0 30px rgba(124, 58, 237, 0.2);\n  --shadow-fun: 8px 8px 0 rgba(124, 58, 237, 0.15);\n\n  /* Responsive spacing */\n  --spacing-page: 1.5rem;\n  --spacing-section: 5rem;\n\n  /* Fun gradients */\n  --gradient-rainbow: linear-gradient(135deg, #ff6b9d 0%, #fbbf24 25%, #4ade80 50%, #06b6d4 75%, #7c3aed 100%);\n  --gradient-sunset: linear-gradient(135deg, #ff6b9d 0%, #fb923c 50%, #fbbf24 100%);\n  --gradient-ocean: linear-gradient(135deg, #06b6d4 0%, #7c3aed 100%);\n  --gradient-candy: linear-gradient(135deg, #ff6b9d 0%, #a78bfa 100%);\n}\n\n/* Responsive breakpoint variables via media queries */\n@media (max-width: 768px) {\n  :root {\n    --spacing-page: 1rem;\n    --spacing-section: 2.5rem;\n    --radius-lg: 18px;\n    --radius-md: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  :root {\n    --spacing-page: 0.75rem;\n    --spacing-section: 2rem;\n    --radius-lg: 14px;\n    --radius-md: 10px;\n  }\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  /* Smooth scrolling for anchor links */\n  scroll-behavior: smooth;\n  /* Prevent horizontal overflow */\n  overflow-x: hidden;\n}\n\nhtml, body, #root {\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n  background: var(--color-background);\n  font-family: 'Nunito', 'Fredoka', 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: var(--color-text);\n  /* Prevent horizontal overflow */\n  overflow-x: hidden;\n  width: 100%;\n}\n\n/* Responsive font sizing */\nhtml {\n  font-size: 16px;\n}\n\n@media (max-width: 768px) {\n  html {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  html {\n    font-size: 14px;\n  }\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: none;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\nbutton {\n  font-family: inherit;\n}\n\n/* Ensure inputs and buttons don't overflow on mobile */\ninput, select, textarea, button {\n  max-width: 100%;\n}\n\n/* Better touch targets on mobile */\n@media (max-width: 768px) {\n  button, \n  a[role=\"button\"],\n  input[type=\"submit\"],\n  input[type=\"button\"] {\n    min-height: 44px;\n  }\n}\n\n/* Hide horizontal scrollbars that might appear */\nbody {\n  overflow-x: hidden;\n}\n\n/* Responsive container utility */\n.container {\n  width: 100%;\n  max-width: var(--max-width);\n  margin-inline: auto;\n  padding-inline: var(--spacing-page);\n}\n\n/* ===== KID-FRIENDLY ANIMATIONS ===== */\n\n/* Bounce animation */\n@keyframes bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n\n/* Wiggle animation */\n@keyframes wiggle {\n  0%, 100% { transform: rotate(0deg); }\n  25% { transform: rotate(-3deg); }\n  75% { transform: rotate(3deg); }\n}\n\n/* Pop animation */\n@keyframes pop {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n  100% { transform: scale(1); }\n}\n\n/* Float animation */\n@keyframes float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-8px); }\n}\n\n/* Sparkle animation */\n@keyframes sparkle {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.6; transform: scale(1.2); }\n}\n\n/* Rainbow text animation */\n@keyframes rainbow {\n  0% { color: #ff6b9d; }\n  20% { color: #fb923c; }\n  40% { color: #fbbf24; }\n  60% { color: #4ade80; }\n  80% { color: #06b6d4; }\n  100% { color: #7c3aed; }\n}\n\n/* Pulse glow */\n@keyframes pulseGlow {\n  0%, 100% { box-shadow: 0 0 20px rgba(255, 107, 157, 0.4); }\n  50% { box-shadow: 0 0 40px rgba(255, 107, 157, 0.6); }\n}\n\n/* Slide up fade in */\n@keyframes slideUpFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Confetti animation */\n@keyframes confettiFall {\n  0% {\n    transform: translateY(-100vh) rotate(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(100vh) rotate(720deg);\n    opacity: 0;\n  }\n}\n\n/* Utility classes for animations */\n.animate-bounce {\n  animation: bounce 2s ease-in-out infinite;\n}\n\n.animate-wiggle {\n  animation: wiggle 1s ease-in-out infinite;\n}\n\n.animate-float {\n  animation: float 3s ease-in-out infinite;\n}\n\n.animate-pop:hover {\n  animation: pop 0.3s ease-in-out;\n}\n\n.animate-sparkle {\n  animation: sparkle 2s ease-in-out infinite;\n}\n\n.animate-pulse-glow {\n  animation: pulseGlow 2s ease-in-out infinite;\n}\n\n.animate-slide-up {\n  animation: slideUpFadeIn 0.5s ease-out forwards;\n}\n\n/* Fun text styles */\n.text-gradient-rainbow {\n  background: var(--gradient-rainbow);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.text-gradient-candy {\n  background: var(--gradient-candy);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Playful heading style */\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Fredoka', 'Nunito', sans-serif;\n  font-weight: 700;\n}\n\n/* Fun button hover effect */\nbutton, a[role=\"button\"], .btn {\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\nbutton:hover, a[role=\"button\"]:hover, .btn:hover {\n  transform: translateY(-3px) scale(1.02);\n}\n\nbutton:active, a[role=\"button\"]:active, .btn:active {\n  transform: translateY(-1px) scale(0.98);\n}\n\n/* Decorative dots pattern */\n.pattern-dots {\n  background-image: radial-gradient(circle, var(--color-primary-light) 2px, transparent 2px);\n  background-size: 24px 24px;\n}\n\n/* Decorative waves */\n.pattern-waves {\n  background:\n    repeating-linear-gradient(\n      45deg,\n      transparent,\n      transparent 10px,\n      rgba(255, 107, 157, 0.05) 10px,\n      rgba(255, 107, 157, 0.05) 20px\n    );\n}\n\n/* Card with fun shadow */\n.card-fun {\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-fun);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.card-fun:hover {\n  transform: translateY(-5px);\n  box-shadow: 12px 12px 0 rgba(124, 58, 237, 0.2);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
